import { render, staticRenderFns } from "./DynamicQuestion.vue?vue&type=template&id=80cfe020&"
import script from "./DynamicQuestion.vue?vue&type=script&lang=js&"
export * from "./DynamicQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80cfe020')) {
      api.createRecord('80cfe020', component.options)
    } else {
      api.reload('80cfe020', component.options)
    }
    module.hot.accept("./DynamicQuestion.vue?vue&type=template&id=80cfe020&", function () {
      api.rerender('80cfe020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/DynamicQuestion/DynamicQuestion.vue"
export default component.exports